//Formik
import { useField } from "formik"

//PrimeReact
import { InputSwitch } from "primereact/inputswitch"

//Styles
import myStyles from "../../../../styles/kiosk/KioskAdminFormWizard.module.css"
import kioskStyles from "../../../../styles/kiosk/KioskAdmin.module.css"
import MessageBodyEditor from "./MessageBodyEditor"

export default function WizardPageActionsSignalR() {
  const emailBodyFieldName = "submitActions[0].notificationBody"

  const [fieldNotifyAdmin, , helpersNotifyAdmin] = useField(
    "submitActions[0].notifyOrganizationAdmin",
  )
  const [fieldNotifyEnt, , helpersNotifyEnt] = useField(
    "submitActions[0].notifyEnterpriseAdmin",
  )

  return (
    <>
      <div className={myStyles.actionNotifyLayout}>
        <div
          className={`${myStyles.actionNotifyTitle} ${myStyles.actionTitle}`}
        >
          Send In-application Notifications
        </div>
        <div className={`${myStyles.actionNotifyOrg} ${myStyles.labelField}`}>
          Notify Organization Admin (s)
        </div>
        <div
          className={`${myStyles.actionNotifyOrgAction} ${kioskStyles.switchControl}`}
        >
          <InputSwitch
            checked={fieldNotifyAdmin.value}
            onChange={(e) => {
              helpersNotifyAdmin.setValue(e.value)
            }}
          />
        </div>
        {/*         <div className={myStyles.actionNotifyDivider}></div>
        <div className={`${myStyles.actionNotifyEnt} ${myStyles.labelField}`}>
          Notify Enterprise Admin (s)
        </div>
        <div
          className={`${myStyles.actionNotifyEntAction} ${kioskStyles.switchControl}`}
        >
          <InputSwitch
            checked={fieldNotifyEnt.value}
            onChange={(e) => {
              helpersNotifyEnt.setValue(e.value)
            }}
          />
        </div> */}
        <div className={myStyles.actionNotifyBody}>
          <hr className={myStyles.modalHeaderLine} />
          <MessageBodyEditor
            bodyFieldName={emailBodyFieldName}
            height={280}
            label={"Message"}
          />
        </div>
      </div>
    </>
  )
}
